import script from "./pixelItem.vue?vue&type=script&setup=true&lang=js"
export * from "./pixelItem.vue?vue&type=script&setup=true&lang=js"

import "./pixelItem.vue?vue&type=style&index=0&id=3938fd2e&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3938fd2e"]])

export default __exports__